// Shared helpers for Wika's progressive enhancements.

export const $ = (selector, root = document) => root.querySelector(selector);
export const $$ = (selector, root = document) => Array.from(root.querySelectorAll(selector));

export function csrfToken() {
  return document.querySelector('meta[name="csrf-token"]')?.content ?? '';
}

/**
 * Submits a form (or FormData) as a JSON-expecting fetch. Resolves to
 * { ok, status, data } and never throws for HTTP errors.
 */
export async function sendForm(form, formData = new FormData(form)) {
  try {
    const response = await fetch(form.action, {
      method: 'POST',
      body: formData,
      headers: { Accept: 'application/json', 'X-CSRF-Token': csrfToken() },
      credentials: 'same-origin',
    });
    let data = {};
    try {
      data = await response.json();
    } catch {
      data = { error: 'Unexpected response from the server.' };
    }
    return { ok: response.ok && data.ok !== false, status: response.status, data };
  } catch {
    return { ok: false, status: 0, data: { error: 'You appear to be offline. Nothing was changed — try again.' } };
  }
}

export function toast(message, { type = 'success', action = null, timeout = 5000 } = {}) {
  const region = document.getElementById('toast-region');
  if (!region) return;
  const el = document.createElement('div');
  el.className = `pointer-events-auto flex max-w-md items-center gap-3 rounded-panel px-4 py-3 text-sm shadow-pop ${
    type === 'error' ? 'bg-rose-700 text-white' : 'bg-ink text-on-ink'
  }`;
  el.setAttribute('role', type === 'error' ? 'alert' : 'status');
  const text = document.createElement('span');
  text.className = 'flex-1';
  text.textContent = message;
  el.append(text);
  if (action) {
    const btn = document.createElement('button');
    btn.type = 'button';
    btn.className = 'rounded px-2 py-1 font-semibold underline-offset-2 hover:underline';
    btn.textContent = action.label;
    btn.addEventListener('click', () => {
      el.remove();
      action.onClick();
    });
    el.append(btn);
  }
  region.append(el);
  setTimeout(() => el.remove(), action ? timeout * 2 : timeout);
}

export function setBusy(button, busy, label) {
  if (!button) return;
  if (busy) {
    button.dataset.originalHtml = button.innerHTML;
    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    button.innerHTML = `<span class="spinner"></span>${label ? `<span>${label}</span>` : ''}`;
  } else if (button.dataset.originalHtml !== undefined) {
    button.disabled = false;
    button.removeAttribute('aria-busy');
    button.innerHTML = button.dataset.originalHtml;
    delete button.dataset.originalHtml;
  }
}
